import React, {useState, useEffect} from 'react';
import { NavLink } from 'react-router-dom';

function Error404() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => { 
    if (isLoading){
      setIsLoading(false);
    }
  }, [isLoading]);
  return (
    <div>
      {isLoading? 
      <div className="flex w-screen h-screen justify-center items-center">
        <div className="flex items-center justify-center ">
            <div className="w-40 h-40 border-t-4 border-b-4 border-primary-100 rounded-full animate-spin"></div>
        </div>
      </div>
      :
      <div className="grid h-screen place-content-center bg-white">
        <div className="text-center">
          <strong className="text-9xl font-black text-gray-200">404</strong>

          <h1 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Uh-oh!
          </h1>

          <p className="mt-4 text-gray-500">Esta página no existe o no se encuentra disponible...</p>

          <NavLink
            to={`/`}
            className="mt-6 inline-block rounded bg-primary-100 px-5 py-3 text-sm font-medium text-white hover:bg-primary-200 focus:outline-none focus:ring"
          >
            Regresar
          </NavLink>
        </div>
      </div>
      }
      
    </div>
  )
}

export default Error404;